import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { helpTipsImg } from '../../../img/images';
import { RootState } from '../../../store';
import { UserRole } from 'susy-common/models';
import { getAllAdminTextsByRole } from '../../../store/actions/AdminTextActions';
import HelpTipItem from '../helpTipItem/HelpTipItem';
import './HelpTipsList.css';
import { IAdminText } from '../../admin/supervisors/interfaces';

interface HelpTipsListProps {
    userRole: UserRole | undefined;
    adminTexts: Array<IAdminText>;
    getAllAdminTextsByRole: () => Promise<void>;
}

export interface HelpTipContentPoint {
    text: string;
}

export interface HelpTipContent {
    description: string;
    points?: Array<HelpTipContentPoint>;
}

export interface HelpTip {
    title: string;
    description: string;
    contents: Array<HelpTipContent>;
}

class HelpTipsList extends React.Component<HelpTipsListProps> {
    componentDidMount = async () => {
        await this.props.getAllAdminTextsByRole();
    };

    render = () => {
        return (
            <Row>
                <Col xs={{ span: 12, order: 2 }} lg={{ span: 7, order: 2 }}>
                    {this.props.adminTexts.map((tip: IAdminText, index) => (
                        <React.Fragment key={index}>
                            <HelpTipItem
                                tip={tip}
                                tipKey={`help-tip-${index}`}
                            />
                        </React.Fragment>
                    ))}
                </Col>
            </Row>
        );
    };
}

const mapStateToProps = (state: RootState) => ({
    adminTexts: state.adminTexts,
});

export default connect(mapStateToProps, {
    getAllAdminTextsByRole,
})(HelpTipsList);
